import { createChildDataApi } from '@clds/compound-components';
export const childDataApi = createChildDataApi('dropdown menu items');
export const useChildRegistry = childDataApi.useChildRegistry;
export const ChildDataRegistryProvider = childDataApi.ChildDataRegistryProvider;
export const useRegisterChildData = childDataApi.useRegisterChildData;
